export {
  AuthNetworkError,
  AuthResponseError,
  AuthApiError,
  AuthAwsError,
  isTransientAuthError,
} from "@skilitics/auth-client";

export type ErrorCode =
  | "incorrectUserOrPassword"
  | "userNotFound"
  | "userAlreadyExists"
  | "userDoesNotExist" // not sure where this comes from?
  | "userNotConfirmed"
  | "userDisabled"
  | "attemptsExceeded"
  | "resetRequired"
  | "signUpNotPermitted" // not permitted at all
  | "signUpRejected" // specific rejection (e.g. throw away email provider)
  | "passwordTooShort"
  | "passwordRequiresUppercase"
  | "passwordRequiresLowercase"
  | "passwordRequiresNumbers"
  | "passwordRequiresSymbols"
  | "expiredCode"
  | "invalidCode"
  | "unknownError";

export interface ErrorInfo {
  code: ErrorCode;
  args?: Record<string, string>;
}

export class AuthError extends Error {
  name = "AuthError";
  code: ErrorCode;
  args?: Record<string, string>;

  constructor(code: ErrorCode, args?: Record<string, string>, options?: ErrorOptions) {
    super(code, options);
    this.code = code;
    this.args = args;
  }
}
